<template>
  <div>
    <NuxtLoadingIndicator />
    <UDashboardPage>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UDashboardPage>
    <CookieControl :locale="vLocaleRef" />
    <UNotifications />
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n({
    useScope: 'local'
  })
  const { $i18n } = useNuxtApp();
  const vLocaleRef = computed(() => $i18n.locale.value);
  useHead({
    title: t('title'),
    link: [{ rel: 'icon', sizes: 'any', href: '/favicon.ico' }],
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
    htmlAttrs: {
      lang: vLocaleRef.value,
    },
  });
  useSeoMeta({
    title: t('seo.title'),
    description: t('seo.description'),
  });
</script>

<i18n lang="yaml">
en:
  title: Regional Wealth, Income and Living Cost Platform
  seo:
    title: Find Your Bubble!
    description: 
      Bunuble is a simple and easy-to-use tool to manage your finances.
      It helps you to keep track of your income and expenses and to make decisions for your future.
      See how a new Job or a new Home affects your standard of living in different parts of Switzerland!
de:
  title: Regionale Wohlstands-, Einkommens- und Lebenshaltungskostenplattform
  seo:
    title: Find Your Bubble!
    description: 
      Bunuble ist ein einfaches und benutzerfreundliches Tool zur Verwaltung Ihrer Finanzen.
      Es hilft Ihnen, den Überblick über Ihre Einnahmen und Ausgaben zu behalten und Entscheidungen für Ihre Zukunft zu treffen.
      Sehen Sie, wie sich ein neuer Job oder ein neues Zuhause auf Ihren Lebensstandard in verschiedenen Teilen der Schweiz auswirkt!
</i18n>